export default __webpack_public_path__ + "static/media/mini_Icon.904edbf6.svg";